import * as React from "react"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

interface ColorPickerProps {
  value: string
  onChange: (color: string) => void
  className?: string
  disabled?: boolean
}

export function ColorPicker({ value, onChange, className, disabled }: ColorPickerProps) {
  const [color, setColor] = React.useState(value)

  React.useEffect(() => {
    setColor(value)
  }, [value])

  const handleColorChange = (newColor: string) => {
    setColor(newColor)
    onChange(newColor)
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn("w-[60px] h-[36px] p-0 border-2", className)}
          disabled={disabled}
        >
          <div
            className="w-full h-full rounded"
            style={{ backgroundColor: color }}
          />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64">
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">Color Picker</label>
            <input
              type="color"
              value={color}
              onChange={(e) => handleColorChange(e.target.value)}
              className="w-full h-32 cursor-pointer rounded border"
            />
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium">Hex Value</label>
            <Input
              value={color}
              onChange={(e) => handleColorChange(e.target.value)}
              placeholder="#000000"
            />
          </div>
          <div className="grid grid-cols-8 gap-2">
            {[
              '#86efac', '#fde047', '#a5f3fc', '#c084fc',
              '#5eead4', '#fca5a5', '#f87171', '#e5e5e5',
              '#22c55e', '#eab308', '#06b6d4', '#a855f7',
              '#14b8a6', '#ef4444', '#f97316', '#6b7280'
            ].map((presetColor) => (
              <button
                key={presetColor}
                className="w-6 h-6 rounded border-2 border-gray-300 hover:border-gray-500 transition-colors"
                style={{ backgroundColor: presetColor }}
                onClick={() => handleColorChange(presetColor)}
              />
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
